import React from 'react'
import PropTypes from 'prop-types'

import Box from '../Box'

const SaveFormModule = (props) => {
  const { boxProps, children } = props

  return (
    <Box
      alignItems="center"
      justifyContent="flex-end"
      marginBottom="large"
      padding="large"
      variant="white"
      {...boxProps}
    >
      <Box width={['100%', 'auto']}>
        {children}
      </Box>
    </Box>
  )
}

SaveFormModule.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
}

export default SaveFormModule
